<template>
    <div>
       <promotions-form 
       :is-promotions-form-sidebar-active.sync="isPromotionsFormSidebarActive"
        :promotions-data="promotionsData"
        @refetch-data="refetchData" 
       />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                            variant="primary"
                            @click="updateData()"
                            >
                                <span class="text-nowrap">Add Promotions</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table
                    ref="refCatListTable"
                    :items="fetchData"
                    responsive
                    :fields="tableColumns"
                   
                    :sort-by.sync="sortBy"
                    show-empty
                    empty-text="No matching records found"
                    :sort-desc.sync="isSortDirDesc"
                    class="position-relative"
            >
            <template #cell(title)="data">
                <span>{{data.item.title[currentLocale]}}</span>
            </template>
            <template #cell(category_title)="data">
                <span>{{data.item.category_title[currentLocale]}}</span>
            </template>
            <template #cell(sub_description)="data">
                <span>{{data.item.sub_description[currentLocale]}}</span>
            </template>
            <template #cell(icon)="data">
                
                <b-img
                
                :src="(data.item.icon?data.item.fullpath:require('@/assets/images/no-image.png'))"
                height="110"
                width="170"
                class="rounded m-0"
                />
            </template>
            <template #cell(is_active)="data">
                    <b-badge
                        pill
                        :variant="`light-${resolveCatStatusVariant(data.item.is_active)}`"
                        class="text-capitalize"
                    >
                        {{ resolveCatStatusnameVariant(data.item.is_active) }} 
                    </b-badge>
                </template>
                <template #cell(action)="data">
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateData(data.item)" variant="outline-success">Edit</b-button>
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(data.item.id)" variant="outline-danger">Delete</b-button>
    
                </template>
            </b-table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalPromotions"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
    </template>
    <script>
    import {
      BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
      BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox
    } from 'bootstrap-vue'
    import Ripple from 'vue-ripple-directive'
    //api
    import axios from '@axios'
    import store from '@/store'
    import { ref,onUnmounted } from '@vue/composition-api'
    import usePromotionsList from './usePromotionsList'
    import promotionsStoreModule from '../promotionsStoreModule'
    import PromotionsForm  from '../promotions-form/PromotionsForm.vue'
    
    import vSelect from 'vue-select'
    export default {
        components:{
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,
            BImg,
            PromotionsForm,
            vSelect
        },
        directives:{
            'b-modal': VBModal,
            Ripple
    
        },
        computed: {
            currentLocale() {
            return  this.$i18n.locale;
            },
        },
        setup(){
            const SERVICES_STORE_MODULE_NAME = 'app-promotions';
            if (!store.hasModule(SERVICES_STORE_MODULE_NAME)) store.registerModule(SERVICES_STORE_MODULE_NAME, promotionsStoreModule)
            onUnmounted(() => {
                if (store.hasModule(SERVICES_STORE_MODULE_NAME)) store.unregisterModule(SERVICES_STORE_MODULE_NAME)
            });
            const {
                promotionsData,
                isPromotionsFormSidebarActive,
                refCatListTable,
                tableColumns,
                perPage,
                totalPromotions,
                currentPage,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                statusFilter,
                dataMeta,
                refetchData,
                fetchData,
                resolveCatStatusVariant,
                resolveCatStatusnameVariant,
                updateData,
                deleteData
            } = usePromotionsList();
            return {
                promotionsData,
                isPromotionsFormSidebarActive,
                refCatListTable,
                tableColumns,
                perPage,
                totalPromotions,
                currentPage,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                statusFilter,
                dataMeta,
                refetchData,
                fetchData,
                resolveCatStatusVariant,
                resolveCatStatusnameVariant,
                updateData,
                deleteData
            }
    
    
        },
        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm('Please confirm that you want to delete Promotions ID.'+id, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                    })
                    .then(value => {
                    if(value === true){
                    this.deleteData(id)
                    }
                
                    //this.deleteData(id)
                    })
    
            },
        }
    }
    
    </script>
    